module.exports = __webpack_public_path__ + "img/educationalPeriods.2ac14ff5.svg";